import React, { useState, useEffect, act } from 'react';
import axios from 'utils/axios';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Select, MenuItem, CircularProgress, Typography, InputLabel, Chip, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, Divider, Stack, List, ListItem, ListItemText, IconButton, Link } from '@mui/material';
import FileUpload from 'components/FileUpload';
import Comments from 'components/Comments';
import { toast } from 'react-toastify';
import { Image } from 'react-bootstrap';
import { MdHistory } from 'react-icons/md';


import { useParams } from 'react-router-dom';

import { handleDownload } from 'utils/functions';
import { formatDateTime } from 'utils/functions';
import {
  MdCheckCircle,
  MdApartment,
  MdAssignmentInd,
  MdArrowBack,
  MdSave,
  MdEdit
} from 'react-icons/md';
import { bytesToBase64 } from 'utils/functions';
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';




const Request = () => {
  const { t } = useTranslation();
  const [requestData, setRequestData] = useState();
  const [requestStatuses, setRequestStatuses] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { identifier } = useParams();
  const [base64Image, setBase64Image] = useState('');
  const [isApproved, setIsApproved] = useState(false);

  const [assignedUser, setAssignedUser] = useState(requestData?.assignedUser || '');
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const [availableUsers, setAvailableUsers] = useState([]);

  const [assignedDepartment, setAssignedDepartment] = useState('');  // Track the selected department
  const [departmentDialogOpen, setDepartmentDialogOpen] = useState(false);  // Open/close state for the dialog
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);  // Open/close state for the dialog
  const [availableDepartments, setAvailableDepartments] = useState([]);
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [requestHistory, setRequestHistory] = useState([]); // State to hold history data
  const [updatedRequestData, setUpdatedRequestData] = useState({
    comment: '',
    statusId: '',
    documents: [],
  });


  const navigate = useNavigate();

  useEffect(() => {
    const fetchRequestData = async (identifier) => {
      try {
        const response = await axios.get('requests/' + identifier);
        setRequestData(response.data);
        setEditedData(response.data);

        setSelectedStatus(response.data.requestStatusId);
        setLoading(false);
        return response.data;

      } catch (err) {
        toast.error('Failed to fetch Request');
        setLoading(false);
      }
    };


    const fetchRequestStatuses = async () => {
      try {
        const response = await axios.get('codebook?codebook=RequestStatuses');
        setRequestStatuses(response.data);
      } catch (err) {
        toast.error('Neuspješno učitavanje statusa zahtjeva');
      }
    };

    fetchRequestData(identifier);
    fetchRequestStatuses();
  }, [identifier]);


  const handleOpenAssignDialog = async () => {
    try {
      const response = await axios.get('requests/getUsers/' + requestData.departmentId);
      console.log(response);
      setAvailableUsers(response.data); // Store users in state
      setAssignDialogOpen(true); // Open the dialog after loading
    } catch (error) {
      console.error('Failed to fetch users:', error);
    }
  };

  const [editing, setEditing] = useState(true);
  const [editedData, setEditedData] = useState({});

  const handleEdit = () => {
    setEditing(true);
    setEditedData(requestData);
  };

  const goBackRequests = () => {
    navigate('/requests');
  };

  const handleSave = async () => {
    try {
      const response = await axios.put('requests/' + identifier, editedData);
      setRequestData(response.data);
      setEditing(false);
    } catch (err) {
      toast.error('Failed to save changes');
    }
  };

  const handleStatusChange = async (event) => {
    var statusData = { statusId: event.target.value };
    const updateRequestModel = {
      requestId: identifier,
      statusId: updatedRequestData.statusId,
      comment: updatedRequestData.comment,
      documents: updatedRequestData.documents
    };
    try {

      const response = await axios.put('requests/' + identifier + '/update', updateRequestModel, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      setSelectedStatus(updatedRequestData.statusId);
      setStatusDialogOpen(false);


      toast.success(t('request_updated_successfully'));
    } catch (err) {
      toast.error(t('failed_to_update_request'));
    }
  };

  const handleApprove = async () => {
    try {
      const response = await axios.put('/requests/' + identifier + '/approve');

      if (response.status === 204) {
        setRequestData((prevData) => ({
          ...prevData,
          approved: true,
        }));
        toast.success(t('request_approved_successfully'));
      }
      //refreshRequests(); 
    } catch (err) {
      console.error('Error approving request:', err);
    }
  };

  const handleAssign = async () => {
    try {
      const response = await axios.put(`/requests/` + identifier + `/assignUser`, assignedUser, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 204) {

        setRequestData((prevData) => ({
          ...prevData,
          assignedUser: assignedUser,
        }))

        setAssignDialogOpen(false);
        toast.success(t('assigned_successfully'));

      };

      //refreshRequests();
    } catch (err) {
      console.error('Error assigning request:', err);
    }
  };

  const handleViewHistory = async () => {
    try {
      const response = await axios.get(`/requests/${identifier}/history`);
      setRequestHistory(response.data); // Assumes the API returns a list of { value, username, actionTypeName, actionTime }
      setHistoryDialogOpen(true);
    } catch (error) {
      console.error('Failed to fetch history:', error);
    }
  };

  useEffect(() => {
    axios.get('codebook?Codebook=Departments')
      .then((res) => setAvailableDepartments(res.data))
      .catch((err) => console.error('Error fetching departments:', err));
  }, []);

  // Submit handler to assign the department
  const handleAssignDepartment = async () => {
    try {
      const response = await axios.put(`/requests/` + identifier + `/assignDepartment`, assignedDepartment, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 204) {
        const selected = availableDepartments.find(d => d.id == assignedDepartment);



        setRequestData((prevData) => ({
          ...prevData,
          department: selected.name,
          departmentId: assignedDepartment,
        }))

        toast.success(t('assigned_successfully'));

      };

      setDepartmentDialogOpen(false);  // Close the dialog after assignment
    } catch (err) {
      console.error('Error assigning department:', err);
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    files.forEach((file) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64 = bytesToBase64(reader.result);
        const newDocument = {
          base64,
          name: file.name,
        };

        setUpdatedRequestData((prevData) => ({
          ...prevData,
          documents: [...prevData.documents, newDocument],
        }));
      };

      reader.readAsArrayBuffer(file);
    });
  };

  const handleRemoveFile = (indexToRemove) => {
    setUpdatedRequestData((prevData) => ({
      ...prevData,
      documents: prevData.documents.filter((_, index) => index !== indexToRemove),
    }));
  };

  return (
    <Box sx={{ p: 4 }}>
      {loading ? (
        <Box display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      ) : (
        <>
          {error && <Typography color="error">{error}</Typography>}

          {editing ? (
            <>
              <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} mb={2}>
                <Typography variant="h5" gutterBottom>
                  {t('editRequest')}
                </Typography>
                <Button
                  startIcon={<MdArrowBack />}
                  variant="outlined"
                  onClick={goBackRequests}
                >
                  {t('back_to_requests')}
                </Button>
              </Box>
              <Divider sx={{ mb: 2 }} />
              <Stack spacing={2}>
                <Stack direction="row" spacing={2}>
                  <TextField
                    label={t('request_title')}
                    value={editedData.name}
                    onChange={(e) =>
                      setEditedData({ ...editedData, name: e.target.value })
                    }
                    fullWidth
                  />
                  <TextField
                    label={t('protocol_number')}
                    value={editedData.workflowNumber || ''}
                    onChange={(e) =>
                      setEditedData({ ...editedData, workflowNumber: e.target.value })
                    }
                    fullWidth
                  />
                </Stack>
                <TextField
                  label={t('requestor')}
                  value={editedData.personName}
                  onChange={(e) =>
                    setEditedData({ ...editedData, personName: e.target.value })
                  }
                  fullWidth
                />
                <TextField
                  label={t('description')}
                  value={editedData.description}
                  onChange={(e) =>
                    setEditedData({ ...editedData, description: e.target.value })
                  }
                  fullWidth
                  multiline
                  rows={4}
                />

                <FormControl fullWidth>
                  <InputLabel id="select-label">{t('status')}</InputLabel>
                  <Select
                    labelId="select-label"
                    value={selectedStatus}
                    //onChange={handleStatusChange}                                       
                    label={t('status')}
                    onClick={(e) => {
                      setStatusDialogOpen(true);
                      setUpdatedRequestData((prevData) => ({
                        ...prevData,
                        statusId: selectedStatus,
                      }));

                    }}
                    open={false}
                  >
                    <MenuItem value="">
                      <em>-- {t('status')} --</em>
                    </MenuItem>
                    {requestStatuses.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Box sx={{ width: '100%' }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    flexWrap="wrap"
                    rowGap={2}
                    columnGap={4}
                    sx={{ width: '100%' }}
                  >
                    {/* Approval Section */}
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Chip
                        label={requestData.approved ? t('approved') : t('not_approved')}
                        color={requestData.approved ? 'success' : 'default'}
                        icon={<MdCheckCircle />}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleApprove}
                        disabled={requestData.approved}
                      >
                        {requestData.approved ? t('approved') : t('approve')}
                      </Button>
                    </Stack>

                    {/* Department Section */}
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Typography variant="subtitle1" sx={{ whiteSpace: 'nowrap' }}>
                        {t('assigned_department')}: <strong>{requestData.department || t('not_assigned')}</strong>
                      </Typography>
                      <Button
                        startIcon={<MdApartment />}
                        variant="outlined"
                        color="primary"
                        //disabled={requestData.departmentId} 
                        onClick={() => setDepartmentDialogOpen(true)}
                      >
                        {/* {requestData.departmentId ? t('change_department') : t('assign_department')} */}
                        {t('assign_department')}

                      </Button>
                    </Stack>

                    {/* User Assignment Section */}
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Chip
                        label={
                          requestData.assignedUser
                            ? `${t('assigned_to')}: ${requestData.assignedUser}`
                            : t('unassigned')
                        }
                        color={requestData.assignedUser ? 'info' : 'default'}
                        icon={<MdAssignmentInd />}
                      />
                      <Button variant="outlined" onClick={handleOpenAssignDialog}>
                        {t('assign_user')}
                      </Button>
                    </Stack>
                  </Stack>
                </Box>

                <Button
                  startIcon={<MdHistory />}
                  variant="outlined"
                  onClick={() => handleViewHistory()}
                >
                  {t('view_history')}
                </Button>

                {/* Conditionally show link to connected request */}
                {requestData.connectedRequestId && (
                  <Typography variant="body2" gutterBottom>
                    <Link href={`/#/requests/${requestData.connectedRequestId}`} underline="hover">
                      {t('connected_request')}
                    </Link>
                  </Typography>
                )}


                <Box>
                  <Typography variant="h6" gutterBottom>
                    {t('documents')}
                  </Typography>

                  <List disablePadding>
                    {requestData.documents.map((item, index) => (
                      <ListItem key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mb: 2 }}>
                        <Box>
                          <Button
                            variant="text"
                            onClick={() => handleDownload(item.id, item.name)}
                            sx={{
                              color: 'primary.main',
                              textTransform: 'none',
                              padding: 0,
                              minWidth: 'auto',
                              '&:hover': {
                                backgroundColor: 'transparent',
                                color: 'primary.main',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                              },
                            }}
                          >
                            {item.name}
                          </Button>
                        </Box>
                        <Typography variant="caption" color="text.secondary">
                          {t('added')}: <strong>{item.createdBy ?? ''}</strong> &nbsp;|&nbsp;
                          {t('date')}: {item.created ? formatDateTime(item.created) : ''}
                        </Typography>
                      </ListItem>
                    ))}
                  </List>
                </Box>

                <Divider sx={{ mt: 4, mb: 2 }} />
                <Comments requestId={identifier} />
              </Stack>

              {/* Assign Dialog */}
              <Dialog
                open={assignDialogOpen}
                onClose={() => setAssignDialogOpen(false)}
                fullWidth
                maxWidth="md"
                PaperProps={{ sx: { minHeight: 300, p: 2 } }}
              >
                <DialogTitle>{t('assign_request')}</DialogTitle>
                <DialogContent>
                  <FormControl fullWidth sx={{ mt: 1 }}>
                    <InputLabel id="assign-user-label">{t('select_user')}</InputLabel>
                    <Select
                      labelId="assign-user-label"
                      value={assignedUser}
                      onChange={(e) => setAssignedUser(e.target.value)}
                      label={t('select_user')}
                    >
                      {availableUsers.map((user) => (
                        <MenuItem key={user} value={user}>
                          {user}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setAssignDialogOpen(false)}>{t('cancel')}</Button>
                  <Button variant="contained" onClick={handleAssign}>
                    {t('assign')}
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Department Dialog */}
              <Dialog
                open={departmentDialogOpen}
                onClose={() => setDepartmentDialogOpen(false)}
                fullWidth
                maxWidth="md"
                PaperProps={{ sx: { minHeight: 300, p: 2 } }}
              >
                <DialogTitle>{t('assign_department')}</DialogTitle>
                <DialogContent>
                  <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel id="assign-department-label">{t('select_department')}</InputLabel>
                    <Select
                      labelId="assign-department-label"
                      value={assignedDepartment}
                      onChange={(e) => setAssignedDepartment(e.target.value)}
                      label={t('select_department')}
                    >
                      {availableDepartments.map((department) => (
                        <MenuItem key={department.id} value={department.id}>
                          {department.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setDepartmentDialogOpen(false)}>{t('cancel')}</Button>
                  <Button variant="contained" onClick={handleAssignDepartment}>
                    {t('assign')}
                  </Button>
                </DialogActions>
              </Dialog>

              {/* History Dialog */}
              <Dialog
                open={historyDialogOpen}
                onClose={() => setHistoryDialogOpen(false)}
                fullWidth
                maxWidth="md"
                PaperProps={{ sx: { minHeight: 300, p: 2 } }}
              >
                <DialogTitle>{t('request_history')}</DialogTitle>
                <DialogContent>
                  {requestHistory && requestHistory.length > 0 ? (
                    <Stack spacing={2}>
                      {requestHistory.map((entry, index) => (
                        <Box key={index} sx={{ borderBottom: '1px solid #ddd', pb: 1 }}>
                          <Typography variant="body1" sx={{ color: 'black' }}>
                            <strong>{entry.actionTypeName}:</strong> {entry.value}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {t('by')}: {entry.username} &nbsp; | &nbsp; {formatDateTime(new Date(entry.actionTime))}
                          </Typography>
                        </Box>
                      ))}
                    </Stack>
                  ) : (
                    <Typography>{t('no_history_available')}</Typography>
                  )}
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setHistoryDialogOpen(false)}>{t('close')}</Button>
                </DialogActions>
              </Dialog>

              {/* Status Dialog */}
              <Dialog
                open={statusDialogOpen}
                onClose={() => setStatusDialogOpen(false)}
                fullWidth
                maxWidth="md"
                PaperProps={{ sx: { minHeight: 300, p: 2 } }}
              >
                <DialogTitle>{t('change_status')}</DialogTitle>
                <DialogContent sx={{ padding: 2 }}>
                  <FormControl fullWidth sx={{ padding: 2 }}>
                    <InputLabel id="select-label">{t('status')}</InputLabel>
                    <Select
                      labelId="select-label"
                      value={updatedRequestData.statusId || ''}
                      //onChange={handleStatusChange}
                      onChange={(e) => {
                        console.log(e.target.value);
                        //setSelectedStatus(e.target.value);
                        setUpdatedRequestData((prevData) => ({
                          ...prevData,
                          statusId: e.target.value,
                        }));
                      }}
                      label={t('status')}
                      onOpen={() => setStatusDialogOpen(true)}
                    >
                      <MenuItem value="">
                        <em>-- {t('status')} --</em>
                      </MenuItem>
                      {requestStatuses.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      color="primary"
                      sx={{ marginTop: 3 }}
                    >
                      {t('upload_documents')}
                      <input
                        type="file"
                        hidden
                        multiple
                        onChange={handleFileChange}
                        accept=".pdf,.docx,.txt,.jpg,.jpeg,.png"
                      />
                    </Button>

                    {updatedRequestData.documents.length > 0 && (
                      <List sx={{ marginTop: 2 }}>
                        {updatedRequestData.documents.map((document, index) => (
                          <ListItem
                            key={index}
                            secondaryAction={
                              <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveFile(index)}>
                                <AiOutlineClose />
                              </IconButton>
                            }
                          >
                            <ListItemText primary={document.name} />
                          </ListItem>
                        ))}
                      </List>
                    )}

                    <Box sx={{ marginBottom: 3, marginTop: 3 }}>
                      <Box sx={{ marginBottom: 3 }}>
                        <TextField
                          label={t('write_a_comment')}
                          multiline
                          rows={4}
                          variant="outlined"
                          fullWidth
                          onChange={(e) =>
                            setUpdatedRequestData((prevData) => ({
                              ...prevData,
                              comment: e.target.value,
                            }))
                          }
                        />
                      </Box>
                    </Box>
                  </FormControl>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', padding: '16px' }}>
                  <Button onClick={() => setStatusDialogOpen(false)}>
                    {t('close')}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleStatusChange}
                    sx={{ padding: '10px 20px' }}
                  >
                    {t('save')}
                  </Button>
                </DialogActions>
              </Dialog>

            </>
          ) : (
            <>
              <Typography variant="h6">Request Details</Typography>
              <Typography>ID: {requestData.id}</Typography>
              <Typography>Username: {requestData.username}</Typography>
              <Typography>Email: {requestData.email}</Typography>
              <Button
                startIcon={<MdEdit />}
                onClick={handleEdit}
                variant="contained"
                sx={{ mt: 2 }}
              >
                Edit
              </Button>
            </>
          )}
        </>
      )}
    </Box>
  );
};

export default Request;
